import { UserPlus, Check, X, PaperPlaneTilt, EnvelopeSimple } from '@phosphor-icons/react';

export default function BuddyRequestSection({ email, setEmail, onSend, sending, error, success, requests, onAccept, onDecline }) {
  return (
    <>
      {/* Send Request */}
      <div className="tactical-card p-6 mb-6" data-testid="send-buddy-request">
        <div className="flex items-center gap-3 mb-4">
          <UserPlus weight="bold" className="w-8 h-8 text-[#FF3B30]" />
          <div>
            <h3 className="text-xl font-bold tracking-tight">FIND A BUDDY</h3>
            <p className="text-sm text-[#A1A1AA]">Enter their email to send a buddy request</p>
          </div>
        </div>

        {error && <div className="bg-[#FF3B30]/10 border border-[#FF3B30]/30 text-[#FF3B30] px-3 py-2 mb-4 text-sm">{error}</div>}
        {success && <div className="bg-[#34C759]/10 border border-[#34C759]/30 text-[#34C759] px-3 py-2 mb-4 text-sm flex items-center gap-2"><Check className="w-4 h-4" /> {success}</div>}

        <form onSubmit={onSend} className="flex gap-2">
          <div className="relative flex-1">
            <EnvelopeSimple className="absolute left-3 top-1/2 -translate-y-1/2 text-[#71717A] w-5 h-5" />
            <input data-testid="buddy-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="buddy@example.com" className="input-tactical pl-11 w-full" required />
          </div>
          <button type="submit" disabled={sending} className="btn-primary px-5 py-3 flex items-center gap-2 whitespace-nowrap" data-testid="send-buddy-request-btn">
            <PaperPlaneTilt weight="bold" className="w-4 h-4" /> {sending ? 'Sending...' : 'Send'}
          </button>
        </form>
      </div>

      {/* Incoming */}
      {requests.incoming.length > 0 && (
        <div className="mb-6">
          <h3 className="text-lg font-bold tracking-tight mb-3">INCOMING REQUESTS</h3>
          <div className="space-y-2">
            {requests.incoming.map(r => (
              <div key={r.id} className="tactical-card p-4 flex items-center justify-between" data-testid={`incoming-request-${r.id}`}>
                <div>
                  <span className="font-bold">{r.from_name}</span>
                  <span className="text-[#71717A] text-sm ml-2">{r.from_email}</span>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => onAccept(r.id)} className="btn-primary px-3 py-1.5 text-xs flex items-center gap-1" data-testid={`accept-${r.id}`}>
                    <Check weight="bold" className="w-3 h-3" /> Accept
                  </button>
                  <button onClick={() => onDecline(r.id)} className="btn-secondary px-3 py-1.5 text-xs flex items-center gap-1" data-testid={`decline-${r.id}`}>
                    <X weight="bold" className="w-3 h-3" /> Decline
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Outgoing */}
      {requests.outgoing.length > 0 && (
        <div className="mb-6">
          <h3 className="text-lg font-bold tracking-tight mb-3">PENDING SENT REQUESTS</h3>
          <div className="space-y-2">
            {requests.outgoing.map(r => (
              <div key={r.id} className="tactical-card p-4 flex items-center justify-between">
                <div>
                  <span className="text-[#A1A1AA]">Sent to </span>
                  <span className="font-bold">{r.to_name || r.to_email}</span>
                </div>
                <span className="text-xs text-[#FF9500] font-bold uppercase">Pending</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* How It Works */}
      <div className="tactical-card p-6 mt-4">
        <h3 className="text-lg font-bold tracking-tight mb-4">HOW BUDDIES WORK</h3>
        <div className="space-y-3 text-sm text-[#A1A1AA]">
          <div className="flex items-start gap-3">
            <span className="w-6 h-6 bg-[#FF3B30]/10 text-[#FF3B30] flex items-center justify-center text-xs font-bold flex-shrink-0">1</span>
            <span>Send a buddy request to someone using their email address</span>
          </div>
          <div className="flex items-start gap-3">
            <span className="w-6 h-6 bg-[#FF3B30]/10 text-[#FF3B30] flex items-center justify-center text-xs font-bold flex-shrink-0">2</span>
            <span>Once they accept, you can see each other's streaks, workouts, and mood</span>
          </div>
          <div className="flex items-start gap-3">
            <span className="w-6 h-6 bg-[#FF3B30]/10 text-[#FF3B30] flex items-center justify-center text-xs font-bold flex-shrink-0">3</span>
            <span>Stay accountable together — when your buddy works out, you'll know!</span>
          </div>
        </div>
      </div>
    </>
  );
}
